import { render, staticRenderFns } from "./privacy-policy-malaysia.vue?vue&type=template&id=ff27d40c&scoped=true&"
import script from "./privacy-policy-malaysia.vue?vue&type=script&lang=ts&"
export * from "./privacy-policy-malaysia.vue?vue&type=script&lang=ts&"
import style0 from "./privacy-policy-malaysia.vue?vue&type=style&index=0&id=ff27d40c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff27d40c",
  null
  
)

export default component.exports